import React from 'react';
import Grid from './UI/Grid';
import StatCard from './UI/StatCard';

import { formatNumber } from '../utils';

const CountryStatList = ({country}) => {
    return <Grid cols={3} colsMd={2} colsSm={1}>
        <StatCard title="Total Cases" info={formatNumber(country.cases)} variant="warning" />
        <StatCard title="Active Cases" info={formatNumber(country.active)} variant="info" />
        <StatCard title="Total Recoveries" info={formatNumber(country.recovered)} variant="success" />
        <StatCard title="Total Deaths" info={formatNumber(country.deaths)} variant="danger" />
        <StatCard title="Critical Cases" info={formatNumber(country.critical)} variant="danger" />
        <StatCard title="Tests" info={formatNumber(country.tests)} variant="info" />
    </Grid>;
};

export default CountryStatList;
